import styles from './table.module.scss'

export default function Row({ children }) {
  return <tr className={styles.row}>{children}</tr>
}
